import type { RequestConfig } from '@customTypes/index';
import type { WorkingConditionDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type GetClubProfileWorkConditionRequest = {
  clubId: string;
};

export type GetClubProfileWorkConditionParams =
  RequestConfig<GetClubProfileWorkConditionRequest>;

export const getClubProfileWorkCondition = async ({
  params,
  config
}: GetClubProfileWorkConditionParams) =>
  api.get<WorkingConditionDto>(
    `/api/ClubProfile/working-conditions/${params.clubId}`,
    config
  );
